<div class="add-edit-contact-wrapper">
	<form [formGroup]="addEditContactInformationFormGroup">
		@if (visibleIfSMSNotification) {
			<div class="add-on-billing-container-grid margin-bottom-20">
				<h4 class="add-on-billing-grid-title" i18n="@@listOfContact-firstName">First Name</h4>
				<h4 class="add-on-billing-grid-title" i18n="@@listOfContact-lastName">Last Name</h4>
				<h4 class="add-on-billing-grid-title" i18n="@@listOfContact-email">Email</h4>
				<h4 class="add-on-billing-grid-title" i18n="@@listOfContact-mobileNumber">Mobile Number</h4>
				<h4 class="add-on-billing-grid-title" i18n="@@listOfContact-onOff">On/Off</h4>
			</div>
		} @else {
			<div class="add-on-billing-container-grid only-visible-few-inputs margin-bottom-20">
				<h4 class="add-on-billing-grid-title" i18n="@@listOfContact-firstName">First Name</h4>
				<h4 class="add-on-billing-grid-title" i18n="@@listOfContact-lastName">Last Name</h4>
				<h4 class="add-on-billing-grid-title" i18n="@@listOfContact-email">Email</h4>
				<h4 class="add-on-billing-grid-title" i18n="@@listOfContact-onOff">On/Off</h4>
			</div>
		}

		@for (groupOfContactDetail of addEditContactDetailsArray.controls; track groupOfContactDetail; let i = $index) {
			<div
				formArrayName="addEditContactDetailsArray"
				[attr.data-automation-id]="'add-edit-contacts-details-' + i + '-container'"
			>
				<div
					[formGroupName]="i"
					class="add-on-billing-container-grid"
					[ngClass]="visibleIfSMSNotification ? '' : 'only-visible-few-inputs'"
				>
					<!-- First-name : -->
					<mat-form-field appearance="outline" class="thin-outline-input-field">
						<input
							matInput
							formControlName="firstName"
							autocomplete="off"
							[attr.data-automation-id]="'first-name-contact-' + i + '-input'"
							(keyup)="inputValuesChange()"
						/>
						@if (
							groupOfContactDetail.get('firstName')?.hasError('required') &&
							(groupOfContactDetail.get('firstName')?.touched || groupOfContactDetail.get('firstName')?.dirty)
						) {
							<mat-error
								i18n="@@addEditContact-firstNameRequired"
								[attr.data-automation-id]="'add-edit-contact-first-name-' + i + '-validation'"
							>
								First Name is required
							</mat-error>
						}
						@if (groupOfContactDetail.get('firstName')?.hasError('maxlength')) {
							<mat-error
								i18n="@@addEditContact-firstNameLength"
								[attr.data-automation-id]="'add-edit-contact-first-name-length-' + i + '-validation'"
							>
								First Name must be at least 1 character and no more than 60 characters
							</mat-error>
						}
					</mat-form-field>
					<!-- Last-name : -->
					<mat-form-field appearance="outline" class="thin-outline-input-field">
						<input
							matInput
							formControlName="lastName"
							autocomplete="off"
							[attr.data-automation-id]="'last-name-contact-' + i + '-input'"
							(keyup)="inputValuesChange()"
						/>
						@if (
							groupOfContactDetail.get('lastName')?.hasError('required') &&
							(groupOfContactDetail.get('lastName')?.touched || groupOfContactDetail.get('lastName')?.dirty)
						) {
							<mat-error
								i18n="@@addEditContact-lastNameRequired"
								[attr.data-automation-id]="'add-edit-contact-last-name-' + i + '-validation'"
							>
								Last Name is required
							</mat-error>
						}
						@if (groupOfContactDetail.get('lastName')?.hasError('maxlength')) {
							<mat-error
								i18n="@@addEditContact-lastNameRequired"
								[attr.data-automation-id]="'add-edit-contact-last-name-length-' + i + '-validation'"
							>
								Last Name must be at least 1 character and no more than 60 characters
							</mat-error>
						}
					</mat-form-field>
					<!-- Email : -->
					<mat-form-field appearance="outline" class="thin-outline-input-field">
						<input
							matInput
							formControlName="email"
							autocomplete="off"
							[attr.data-automation-id]="'email-contact-' + i + '-input'"
							autocomplete="email"
							(keyup)="inputValuesChange()"
						/>
						@if (
							(groupOfContactDetail.get('email')?.touched || groupOfContactDetail.get('email')?.dirty) &&
							groupOfContactDetail.get('email')?.hasError('required') &&
							flagForPhoneNumberErrorMessage
						) {
							<mat-error
								i18n="@@addEditContact-emailOrMobileRequired"
								[attr.data-automation-id]="'add-edit-contact-email-mobile-' + i + '-validation'"
							>
								Email or Mobile number required to enable notifications
							</mat-error>
						}
						@if (groupOfContactDetail.get('email')?.hasError('email') && groupOfContactDetail.get('email')?.value) {
							<mat-error
								i18n="@@addEditContact-emailInvalid"
								[attr.data-automation-id]="'add-edit-contact-email-invalid-' + i + '-validation'"
							>
								Email must contain '&#64;' and '.' in that order
							</mat-error>
						}
					</mat-form-field>
					<!-- Phone Type & Number : -->
					@if (visibleIfSMSNotification) {
						<app-contact-phone-type-form
							class="column"
							[isDisabled]="false"
							[flagForDisplayErrorMessage]="
								groupOfContactDetail.get('email')?.touched ||
								groupOfContactDetail.get('email')?.dirty ||
								groupOfContactDetail.get('email')?.value
									? false
									: true
							"
							[existingPhoneNumber]="groupOfContactDetail?.get('phoneNumber')?.value"
							(userPhoneNumber)="updateUserPhone($event, i)"
						>
						</app-contact-phone-type-form>
					}
					<!-- On / Off Toggle : -->
					<mat-slide-toggle
						formControlName="isActive"
						class="thin-outline-input-field on-off-toggle"
						[attr.data-automation-id]="'on-off-detail-contact-' + i + '-input'"
					></mat-slide-toggle>
					<!-- Trashcan Icon : -->
					<div class="trash-can-icon-container">
						<mat-icon
							svgIcon="sl-trash"
							class="trash-can-icon"
							(click)="removeRow(i)"
							[attr.data-automation-id]="'remove-contact-' + i + '-button'"
						></mat-icon>
					</div>
				</div>
			</div>
		}

		@if (this.addEditContactDetailsArray.length < 5) {
			<button
				mat-stroked-button
				(click)="defaultRowAdd($event)"
				class="incremental-button"
				data-automation-id="add-contract-increment-button"
			>
				+
			</button>
		}
	</form>
</div>
